import { Icon } from '@iconify/react';
import image2Fill from '@iconify/icons-eva/image-2-fill';
import dashboard2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import peopleFill from '@iconify/icons-eva/people-fill';
import fileTextFill from '@iconify/icons-eva/file-text-fill';
import lockFill from '@iconify/icons-eva/lock-fill';
import personAddFill from '@iconify/icons-eva/person-add-fill';
import alertTriangleFill from '@iconify/icons-eva/alert-triangle-fill';
// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: 'Projects',
    path: '/projects',
    icon: getIcon(image2Fill)
  },
  {
    title: 'Employees',
    path: '/employees',
    icon: getIcon(peopleFill)
  },
  {
    title: 'About page',
    path: '/pages/about',
    icon: getIcon(fileTextFill)
  },
  {
    title: 'Contact page',
    path: '/pages/contact',
    icon: getIcon(fileTextFill)
  },
  {
    title: 'Join Us Page',
    path: '/pages/join-us',
    icon: getIcon(fileTextFill)
  }
];

export default sidebarConfig;
